import axios from 'axios'

export default {
    namespaced: true,
    actions: {
        FetchAddressByPostCode({ }, obj) {
            return new Promise((resolve, reject) => {
                axios.post(`${process.env.BASE_URL}api/addresses/fetch/post-code`, obj, { headers: { Authorization: `Bearer ${sessionStorage.appToken}` } })
                    .then(response => {
                        if (response.data.success) resolve(response.data);
                        else reject(response.data.message);
                    }).catch(error => reject(`FetchAddressByPostCode: ${error.message}`));
            });
        },
    },
}
